import { useContext } from 'react';
import { Outlet } from "react-router-dom";
import { AuthContext } from '../contexts/AuthContext';
import { EUserRole } from "../types/enums";
import { NotFound } from "../views/NotFound";

interface ProtectedRouteProps {
  allowedRoles: EUserRole[];
}

export function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const { authInfo, isAuthResolved } = useContext(AuthContext);

  if (!isAuthResolved) {
    return null;
  }
  
  if (!authInfo?.role || !allowedRoles.includes(authInfo.role)) {
    return <NotFound reason="forbidden" />;
  }
  
  return <Outlet />;
}
